import { TableColumnMeta } from "ds/components/Table/types";

export const STACK_ROLES_STORAGE_KEY = "stackRolesTable";
export const STACK_ROLES_FILTERS_STORAGE_KEY = "stackRolesFilters";

export enum STACK_ROLES_COLUMN_ID {
  ROLE = "ROLE",
  DESCRIPTION = "DESCRIPTION",
  SPACE = "SPACE",
  ROW_ACTIONS = "ROW_ACTIONS",
}

const MAX_CELL_WIDTH = 600;

export const STACK_ROLES_COLUMN_CONFIG: Record<STACK_ROLES_COLUMN_ID, TableColumnMeta> = {
  [STACK_ROLES_COLUMN_ID.ROLE]: {
    id: STACK_ROLES_COLUMN_ID.ROLE,
    title: "Role",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [STACK_ROLES_COLUMN_ID.DESCRIPTION]: {
    id: STACK_ROLES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 200,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [STACK_ROLES_COLUMN_ID.SPACE]: {
    id: STACK_ROLES_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 120,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [STACK_ROLES_COLUMN_ID.ROW_ACTIONS]: {
    id: STACK_ROLES_COLUMN_ID.ROW_ACTIONS,
    title: "",
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const STACK_ROLES_SORT_CONFIG = {
  [STACK_ROLES_COLUMN_ID.ROLE]: "role",
  [STACK_ROLES_COLUMN_ID.SPACE]: "space",
};
